import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutGrid, LogOut, User, BarChart3 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-xl border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <div className="h-8 w-8 rounded-lg bg-slate-900 flex items-center justify-center text-white font-semibold">I</div>
          <span className="font-medium text-lg tracking-tight text-slate-900">IdeSetGo</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
          <a href="/#funksjoner" className="hover:text-slate-900 transition-colors" data-testid="nav-funksjoner">Funksjoner</a>
          <a href="/#slik-fungerer-det" className="hover:text-slate-900 transition-colors" data-testid="nav-how">Slik fungerer det</a>
          <Link to="/eksempler" className="hover:text-slate-900 transition-colors" data-testid="nav-eksempel">Eksempler</Link>
          <a href="/#priser" className="hover:text-slate-900 transition-colors" data-testid="nav-priser">Priser</a>
          <a href="/#faq" className="hover:text-slate-900 transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="ghost"
                onClick={() => navigate("/dashboard")}
                className="rounded-full hidden sm:inline-flex"
                data-testid="nav-dashboard-btn"
              >
                <LayoutGrid className="h-4 w-4 mr-2" /> Dashbord
              </Button>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="outline" className="rounded-full" data-testid="nav-user-menu">
                    <User className="h-4 w-4 mr-2" />
                    <span className="max-w-[120px] truncate">{user.name?.split(" ")[0] || "Konto"}</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-52">
                  <DropdownMenuItem onClick={() => navigate("/dashboard")} data-testid="menu-dashboard">
                    <LayoutGrid className="h-4 w-4 mr-2" /> Dashbord
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => navigate("/profil")} data-testid="menu-profile">
                    <User className="h-4 w-4 mr-2" /> Min profil
                  </DropdownMenuItem>
                  {user.is_admin && (
                    <DropdownMenuItem onClick={() => navigate("/admin")} data-testid="menu-admin">
                      <BarChart3 className="h-4 w-4 mr-2" /> Admin
                    </DropdownMenuItem>
                  )}
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={logout} data-testid="menu-logout">
                    <LogOut className="h-4 w-4 mr-2" /> Logg ut
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                onClick={() => navigate("/login")}
                className="rounded-full"
                data-testid="nav-login-btn"
              >
                Logg inn
              </Button>
              <Button
                onClick={() => navigate("/register")}
                className="rounded-full bg-slate-900 hover:bg-slate-800 text-white"
                data-testid="nav-register-btn"
              >
                Kom i gang
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
